import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {MsalGuard} from '@azure/msal-angular';
import {PAGES_CONFIG} from '../shared/constants/pages.constants';
import {AuthGuard} from '../shared/guards/auth.guard';
import {SubstitesComponent} from './pages/substites/substitutes.component';

const routes: Routes = [
  {
    path: PAGES_CONFIG.SUBSTITUTES,
    component: SubstitesComponent,
    canActivate: [MsalGuard, AuthGuard]
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SubstituteRoutingModule { }
